import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Box, Typography, Chip } from '@mui/material';
import { Outlet, useLocation } from 'react-router-dom';
import { colors } from '../../football/colors';

/** ARCHIVE-1: the tournament is over and the backend is decommissioned.
 * The layout no longer fetches fixtures or renders live tabs — it frames
 * the archived Track Record (the index route redirects there) plus static
 * "tournament concluded" stand-ins for the old live/standings/knockouts
 * URLs, which are kept so old links and prerendered pages don't 404.
 */

function useRouteMeta(pathname: string) {
  if (pathname.startsWith('/football/world-cup-2026/track-record')) {
    return {
      title: 'Prediction Track Record — FIFA World Cup 2026 | FantasyFuel',
      description:
        'Final archived record of our FIFA World Cup 2026 predictions — winners called in 69 of 104 matches (66.3%): 62.5% group stage, 75.0% knockouts. Every call graded.',
    };
  }
  return {
    title: 'FIFA World Cup 2026 — Tournament Concluded | FantasyFuel',
    description:
      'The FIFA World Cup 2026 has concluded. View the final archived prediction track record.',
  };
}

const WorldCup2026Layout: React.FC = () => {
  const location = useLocation();
  const { title, description } = useRouteMeta(location.pathname);

  return (
    <>
      <Helmet>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta property="og:title" content={title} />
        <meta property="og:description" content={description} />
      </Helmet>
      <Box sx={{ maxWidth: 700, mx: 'auto', px: { xs: 1, sm: 2 }, py: 3 }}>
        <Typography
          variant="h4"
          sx={{
            textAlign: 'center',
            mb: 1,
            fontSize: { xs: '1.5rem', sm: '2.125rem' },
          }}
        >
          FIFA World Cup 2026
        </Typography>
        <Box sx={{ textAlign: 'center', mb: 3 }}>
          <Chip
            data-testid="archive-banner"
            label="🏆 Tournament concluded · Final archived record"
            sx={{
              color: colors.darkText,
              backgroundColor: colors.homeAccent,
              fontWeight: 700,
              height: 'auto',
              maxWidth: '100%',
              py: 0.5,
              '& .MuiChip-label': { whiteSpace: 'normal' },
            }}
          />
        </Box>
        <Outlet />
      </Box>
    </>
  );
};

export default WorldCup2026Layout;
